import { useMutation } from '@tanstack/react-query';
import { toast } from 'sonner';
import { EndCampaign } from '../api';
import { useInvalidateAllCampaigns } from './use-invalidate-all-campaigns';

export const useEndCampaignMutation = () => {
  const invalidateAllCampaigns = useInvalidateAllCampaigns();

  const endCampaignMutation = useMutation({
    mutationFn: ({ campaignId }: { campaignId: string }) => EndCampaign(campaignId),
    onSuccess: async () => {
      await invalidateAllCampaigns();
      toast.success('Campaign will end tomorrow.');
    },
    onError: () => {
      toast.error('Failed to end campaign. Please try again.');
    },
  });

  return endCampaignMutation;
};
